import { BorrowerInputVariables, InputLabel } from '@sparrow-card/sparrow-card-constants';
import Link from 'components/Link';

export const CHECK_BOX_TERM_LABEL = (
  <>
    By clicking this checkbox, I certify that I’ve read and agree to the above terms of the Sparrow
    account, including the information about eligibility, rates, fees, and other costs. I understand
    that the terms of my account, including the APR’s, are subject to change. Any such change will
    be made in accordance with the Cardmember Agreement.
  </>
);

export const buildCommunicationsLabel = (href: string) => (
  <>
    Paperless Communications and Statements: By clicking this checkbox, I certify that I’ve read and
    agree to the{' '}
    <Link target="_blank" href={href}>
      Electronic Communications Agreement
    </Link>
    . By agreeing, I understand that I am consenting to receive electronically (instead of paper)
    all communications about my application, as well as with my account if I am approved. I
    understand that I may change my paperless settings once I set up online access.
  </>
);

export const buildContractedLabel = (href: string) => (
  <>
    By clicking this checkbox, I certify that I have read the{' '}
    <Link target="_blank" href={href}>
      Consent to be Contacted by Telephone, Email, or Postal Mail
    </Link>
    , and agree that Sparrow may contact me via automated text or phone calls, including through the
    use of automatic dialing technology, for any lawful purpose such as informational, servicing,
    collections, or other activities relating to my account. Message and data rates may apply.
  </>
);

export const CHECK_BOX_REPORT_LABEL = (
  <>
    Credit Report Authorization: By clicking this checkbox, I certify that I’ve read and agree to
    the{' '}
    <Link target="_blank" href="https://www.sparrowcard.com/legal/credit-report-authorization">
      Credit Report Authorization Agreement
    </Link>
    , and I authorize Sparrow to obtain my personal credit profile information from one or more
    credit reporting agencies to determine if I qualify for this offer. I understand that, if my
    application is approved, a hard inquiry will appear on my credit report and may impact my credit
    score. If I become an accountholder, Sparrow will continue to obtain and use my credit
    information on an ongoing basis.
  </>
);

export const LocationInputsNames = {
  street: BorrowerInputVariables.Street,
  state: BorrowerInputVariables.State,
  zip: BorrowerInputVariables.Zip,
  unit: BorrowerInputVariables.Unit,
  city: BorrowerInputVariables.City,
};

export const LocationInputsLabels = {
  street: InputLabel.Street,
  state: InputLabel.State,
  zip: InputLabel.Zip,
  unit: InputLabel.Unit,
  city: InputLabel.City,
};

export const CHECKBOX_LABELS_DEFAULT = {
  [BorrowerInputVariables.CheckBoxTerms]: CHECK_BOX_TERM_LABEL,
  [BorrowerInputVariables.CheckBoxElectronicCommunications]: buildCommunicationsLabel(
    'https://www.sparrowcard.com/legal/electronic-communication-consent',
  ),
  [BorrowerInputVariables.CheckBoxContracted]: buildContractedLabel(
    'https://www.sparrowcard.com/legal/consent-to-be-contacted',
  ),
  [BorrowerInputVariables.CheckBoxCreditReport]: CHECK_BOX_REPORT_LABEL,
};

export const CHECKBOX_LABELS_FNBL = {
  [BorrowerInputVariables.CheckBoxTerms]: CHECK_BOX_TERM_LABEL,
  [BorrowerInputVariables.CheckBoxElectronicCommunications]: buildCommunicationsLabel(
    'https://sparrowcard.com/privacy_policy/electronic-communications-consent-for-fnbl-cards/',
  ),
  [BorrowerInputVariables.CheckBoxContracted]: buildContractedLabel(
    'https://sparrowcard.com/privacy_policy/consent-to-be-contacted-for-fnbl-cards/',
  ),
  [BorrowerInputVariables.CheckBoxCreditReport]: CHECK_BOX_REPORT_LABEL,
};

export const CHECKBOX_LABELS_FOCUS = {
  [BorrowerInputVariables.CheckBoxTerms]: CHECK_BOX_TERM_LABEL,
  [BorrowerInputVariables.CheckBoxElectronicCommunications]: buildCommunicationsLabel(
    'https://sparrowcard.com/privacy_policy/electronic-communications-consent-for-focus-cards/',
  ),
  [BorrowerInputVariables.CheckBoxContracted]: buildContractedLabel(
    'https://sparrowcard.com/privacy_policy/consent-to-be-contacted-for-focus-cards/',
  ),
  [BorrowerInputVariables.CheckBoxCreditReport]: CHECK_BOX_REPORT_LABEL,
};
